// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"nm","modalContent":"om","header":"pm","close":"qm"};